import React from "react";
import Typography from "@mui/material/Typography";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

// Release notes are authored in a small, controlled markdown subset (see
// releases/*.md): "### Heading" sections and "- bullet" lines. No general
// markdown renderer is used since we fully control the input format.
const parseSections = body => {
  const lines = (body || "").split("\n");
  const sections = [];
  let current = null;

  lines.forEach(line => {
    const heading = line.match(/^###\s+(.*)/);
    const bullet = line.match(/^-\s+(.*)/);

    if (heading) {
      current = { heading: heading[1].trim(), items: [] };
      sections.push(current);
    } else if (bullet && current) {
      current.items.push(bullet[1].trim());
    }
  });

  return sections;
};

const ReleaseBody = ({ body }) => {
  const sections = parseSections(body);

  return (
    <>
      {sections.map(section => (
        <React.Fragment key={section.heading}>
          <Typography variant="subtitle1" fontWeight={600} mt={2}>
            {section.heading}
          </Typography>
          <List dense disablePadding>
            {section.items.map(item => (
              <ListItem key={item} sx={{ display: "list-item", listStyleType: "disc", ml: 3, py: 0.25 }}>
                <Typography variant="body2">{item}</Typography>
              </ListItem>
            ))}
          </List>
        </React.Fragment>
      ))}
    </>
  );
};

export default ReleaseBody;
